import { Table, TableCell, TableContainer, TableHead, TableRow, Typography, Box, TextField, TableBody, Button, Grid, Divider } from '@mui/material'
import React, { useEffect, useState } from 'react'

export default function Bloque2({ text2, handleDatosTextField2 }) {

    useEffect(() => {
        console.log(text2)
    }, [text2])


    const [mostrar, setMostrar] = useState(false)



    const handleMostar = () => {
        setMostrar(!mostrar)
    }

    const [mostrar1, setMostrar1] = useState(false)



    const handleMostar1 = () => {
        setMostrar1(!mostrar1)
    }

    return (

        <>
            <Divider style={{ marginTop: "20px" }} />
            <div style={{ marginTop: "20px" }}>
                <Typography style={{ fontSize: "17px" }} ><b>Refracción Objetiva</b></Typography>



                <Box style={{ display: "flex", justifyContent: "right", justifyItems: "right", alignContent: "right", alignItems: "right", marginTop: "-35px" }}>
                    <Button style={{ position: "relative", zIndex: "9999 !important" }} variant='outlined' onClick={handleMostar1}>{!mostrar1 ? "Mostrar Valores" : "Ocultar Valores"}</Button>
                </Box>
                <TableContainer style={{ marginTop: "10px" }}>
                    {
                        mostrar1 &&
                        <>

                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ fontSize: "14px", color: "transparent" }} align="left"><b>T.</b></TableCell>
                                        <TableCell style={{ fontSize: "14px" }} align="center"><b>ESF</b></TableCell>
                                        <TableCell style={{ fontSize: "14px" }} align="center"><b>CIL</b></TableCell>
                                        <TableCell style={{ fontSize: "14px" }} align="center"><b>EJE</b></TableCell>
                                        <TableCell style={{ fontSize: "14px" }} align="center"><b>DIP</b></TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>


                                    {
                                        text2.map((x, ix) =>
                                            <TableRow key={ix} style={{ width: "100px", display: (x.id === "gafas" || x.id === "lentesContacto" || x.id === "autoreflexion" || x.id === 'mediaDistancia' || x.id === 'refraccion' || x.id === 'cerca' || x.id === "lejos" || x.id === "add") ? "none" : null }} hover>
                                                <>
                                                    <TableCell align="top">
                                                        <Box style={{ textAlign: "left", marginTop: "-55px" }}>
                                                            <Typography>
                                                                {x.label}
                                                            </Typography>
                                                        </Box>
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        <Box style={{ display: "flex" }}>
                                                            <Box style={{ marginTop: "15px" }}>
                                                                <Typography>
                                                                    {x.labe1}
                                                                </Typography>
                                                            </Box>
                                                            <Box style={{ display: "flex", flexDirection: "column", justifyContent: "space-evenly", justifyItems: "center", alignContent: "center", alignItems: "center" }}>
                                                                <Box style={{ display: "flex", justifyContent: "space-evenly", justifyItems: "top", alignContent: "top", alignItems: "top" }}>
                                                                    <Box>
                                                                        {console.log(x.esf1)}
                                                                        <TextField
                                                                            value={x.esf1}
                                                                            style={{ maxWidth: "90px" }}
                                                                            className='hola5'
                                                                            onChange={(e) => handleDatosTextField2(x.id, e.target.value, 'esf1')}
                                                                        />
                                                                    </Box>
                                                                    {/* <Box>
                                                                °
                                                            </Box> */}
                                                                </Box>
                                                                <TableCell align="left">
                                                                    <Box style={{ marginLeft: "-112px", marginRight: "20px" }}>
                                                                        <Typography>
                                                                            {x.label0}
                                                                        </Typography>
                                                                    </Box>
                                                                    <Box style={{ display: "flex", justifyContent: "space-evenly", justifyItems: "center", alignContent: "center", alignItems: "center" }}>
                                                                        <Box style={{ marginLeft: "-35px", marginRight: "20px" }}>
                                                                            <Typography>
                                                                                {x.label2}
                                                                            </Typography>
                                                                        </Box>
                                                                        <Box>
                                                                            <TextField
                                                                                value={x.esf2}
                                                                                style={{ width: "90px" }}
                                                                                className='hola6'
                                                                                onChange={(e) => handleDatosTextField2(x.id, e.target.value, 'esf2')}
                                                                            />
                                                                        </Box>

                                                                    </Box>
                                                                </TableCell>
                                                            </Box>
                                                        </Box>
                                                    </TableCell>



                                                    <TableCell align="center">

                                                        <Box style={{ display: "flex" }} >
                                                            {/* <Box style={{ marginTop: "15px" }}>
                                                        <Typography>
                                                            {x.labe1}
                                                        </Typography>
                                                    </Box> */}

                                                            <Box style={{ display: "flex", flexDirection: "column", justifyContent: "space-evenly", justifyItems: "center", alignContent: "center", alignItems: "center" }}>
                                                                <Grid container>
                                                                    <Grid lg={11}>
                                                                        <TextField
                                                                            value={x.cil1}
                                                                            style={{ maxWidth: "90px" }}
                                                                            className='hola1'
                                                                            onChange={(e) => handleDatosTextField2(x.id, e.target.value, 'cil1')}
                                                                        />
                                                                    </Grid>
                                                                    <Grid lg={1}>
                                                                        <Box style={{ marginLeft: "20px", marginTop: "15px" }}>X</Box>
                                                                    </Grid>
                                                                </Grid>
                                                                <TableCell align="left">
                                                                    <Box style={{ display: "flex", justifyContent: "space-evenly", justifyItems: "center", alignContent: "center", alignItems: "center" }}>
                                                                        {/* <Box style={{ marginLeft: "-35px", marginRight: "20px" }}>
                                                                    <Typography>
                                                                        {x.label2}
                                                                    </Typography>
                                                                </Box> */}
                                                                        <Box>
                                                                            <Grid container>
                                                                                <Grid lg={11}>
                                                                                    <TextField
                                                                                        value={x.cil2}
                                                                                        style={{ width: "90px", marginLeft: "33px" }}
                                                                                        className='hola2'
                                                                                        onChange={(e) => handleDatosTextField2(x.id, e.target.value, 'cil2')}
                                                                                    />
                                                                                </Grid>
                                                                                <Grid lg={1}>
                                                                                    <Box style={{ marginLeft: "33px", marginTop: "15px" }}>X</Box>
                                                                                </Grid>
                                                                            </Grid>
                                                                        </Box>

                                                                    </Box>
                                                                </TableCell>
                                                            </Box>

                                                        </Box>

                                                    </TableCell>



                                                    <TableCell align="center">
                                                        <Box style={{ display: "flex", flexDirection: "column", justifyContent: "space-evenly", justifyItems: "center", alignContent: "center", alignItems: "center" }}>
                                                            <Box style={{ display: "flex", justifyContent: "space-evenly", justifyItems: "top", alignContent: "top", alignItems: "top" }}>
                                                                <TextField
                                                                    value={x.x1}
                                                                    style={{ maxWidth: "90px" }}
                                                                    className='hola3'
                                                                    onChange={(e) => handleDatosTextField2(x.id, e.target.value, 'x1')}
                                                                />
                                                                <Box>
                                                                    °
                                                                </Box>
                                                            </Box>
                                                            <TableCell align="left">
                                                                <Box style={{ display: "flex", justifyContent: "space-evenly", justifyItems: "top", alignContent: "top", alignItems: "top" }}>
                                                                    <Box>
                                                                        <TextField
                                                                            value={x.x2}
                                                                            style={{ width: "90px" }}
                                                                            className='hola4'
                                                                            onChange={(e) => handleDatosTextField2(x.id, e.target.value, 'x2')}
                                                                        />
                                                                    </Box>
                                                                    <Box>
                                                                        °
                                                                    </Box>
                                                                </Box>
                                                            </TableCell>
                                                        </Box>
                                                    </TableCell>



                                                    <TableCell align="center">
                                                        <Box style={{ display: "flex", flexDirection: "column", justifyContent: "space-evenly", justifyItems: "center", alignContent: "center", alignItems: "center" }}>
                                                            <Box style={{ display: "flex", justifyContent: "space-evenly", justifyItems: "top", alignContent: "top", alignItems: "top" }}>
                                                                <Box>
                                                                    <TextField
                                                                        value={x.rec1}
                                                                        style={{ maxWidth: "90px" }}
                                                                        className='hola5'
                                                                        onChange={(e) => handleDatosTextField2(x.id, e.target.value, 'rec1')}
                                                                    />
                                                                </Box>
                                                                <Box>
                                                                    °
                                                                </Box>
                                                            </Box>
                                                            <TableCell align="left">
                                                                <Box style={{ display: "flex", justifyContent: "space-evenly", justifyItems: "top", alignContent: "top", alignItems: "top" }}>
                                                                    <Box>
                                                                        <TextField
                                                                            value={x.rec2}
                                                                            style={{ width: "90px" }}
                                                                            className='hola6'
                                                                            onChange={(e) => handleDatosTextField2(x.id, e.target.value, 'rec2')}
                                                                        />
                                                                    </Box>
                                                                    <Box>
                                                                        °
                                                                    </Box>
                                                                </Box>
                                                            </TableCell>
                                                        </Box>
                                                    </TableCell>


                                                </>
                                            </TableRow>
                                        )
                                    }



                                </TableBody>

                            </Table>

                        </>
                    }



                </TableContainer>

            </div>

            <Divider style={{ marginTop: "5px" }} />
            <div style={{ marginTop: "20px" }}>
                <Typography style={{ fontSize: "17px" }} ><b>Refracción Subjetiva</b></Typography>



                <Box style={{ display: "flex", justifyContent: "right", justifyItems: "right", alignContent: "right", alignItems: "right", marginTop: "-35px" }}>
                    <Button style={{ position: "relative", zIndex: "9999 !important" }} variant='outlined' onClick={handleMostar}>{!mostrar ? "Mostrar Valores" : "Ocultar Valores"}</Button>
                </Box>
                <TableContainer style={{ marginTop: "10px" }}>
                    {
                        mostrar &&
                        <>

                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ fontSize: "14px", color: "transparent" }} align="left"><b>T.</b></TableCell>
                                        <TableCell style={{ fontSize: "14px" }} align="center"><b>ESF</b></TableCell>
                                        <TableCell style={{ fontSize: "14px" }} align="center"><b>CIL</b></TableCell>
                                        <TableCell style={{ fontSize: "14px" }} align="center"><b>EJE</b></TableCell>
                                        <TableCell style={{ fontSize: "14px" }} align="center"><b>DIP</b></TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>


                                    {
                                        text2.map((x, ix) =>
                                            <TableRow key={ix} style={{ width: "100px", display: (x.id === "gafas" || x.id === "lentesContacto" || x.id === "autoreflexion" || x.id === 'mediaDistancia' || x.id === 'refraccion' || x.id === 'lejosObjetiva' || x.id === 'cerca') ? "none" : null }} hover>
                                                <>
                                                    <TableCell align="top">
                                                        <Box style={{ textAlign: "left", marginTop: "-55px" }}>
                                                            <Typography>
                                                                {x.label}
                                                            </Typography>
                                                        </Box>
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        <Box style={{ display: "flex" }}>
                                                            <Box style={{ marginTop: "15px" }}>
                                                                <Typography>
                                                                    {x.labe1}
                                                                </Typography>
                                                            </Box>
                                                            <Box style={{ display: "flex", flexDirection: "column", justifyContent: "space-evenly", justifyItems: "center", alignContent: "center", alignItems: "center" }}>
                                                                <Box style={{ display: "flex", justifyContent: "space-evenly", justifyItems: "top", alignContent: "top", alignItems: "top" }}>
                                                                    <Box>
                                                                        {console.log(x.esf1)}
                                                                        <TextField
                                                                            value={x.esf1}
                                                                            style={{ maxWidth: "90px" }}
                                                                            className='hola5'
                                                                            onChange={(e) => handleDatosTextField2(x.id, e.target.value, 'esf1')}
                                                                        />
                                                                    </Box>
                                                                    {/* <Box>
                                                                °
                                                            </Box> */}
                                                                </Box>
                                                                <TableCell align="left">
                                                                    <Box style={{ marginLeft: "-112px", marginRight: "20px" }}>
                                                                        <Typography>
                                                                            {x.label0}
                                                                        </Typography>
                                                                    </Box>
                                                                    <Box style={{ display: "flex", justifyContent: "space-evenly", justifyItems: "center", alignContent: "center", alignItems: "center" }}>
                                                                        <Box style={{ marginLeft: "-35px", marginRight: "20px" }}>
                                                                            <Typography>
                                                                                {x.label2}
                                                                            </Typography>
                                                                        </Box>
                                                                        <Box>
                                                                            <TextField
                                                                                value={x.esf2}
                                                                                style={{ width: "90px" }}
                                                                                className='hola6'
                                                                                onChange={(e) => handleDatosTextField2(x.id, e.target.value, 'esf2')}
                                                                            />
                                                                        </Box>

                                                                    </Box>
                                                                </TableCell>
                                                            </Box>
                                                        </Box>
                                                    </TableCell>



                                                    <TableCell align="center">

                                                        <Box style={{ display: "flex" }} >
                                                            {/* <Box style={{ marginTop: "15px" }}>
                                                        <Typography>
                                                            {x.labe1}
                                                        </Typography>
                                                    </Box> */}

                                                            <Box style={{ display: "flex", flexDirection: "column", justifyContent: "space-evenly", justifyItems: "center", alignContent: "center", alignItems: "center" }}>
                                                                <Grid container>
                                                                    <Grid lg={11}>
                                                                        <TextField
                                                                            value={x.cil1}
                                                                            style={{ maxWidth: "90px" }}
                                                                            className='hola1'
                                                                            onChange={(e) => handleDatosTextField2(x.id, e.target.value, 'cil1')}
                                                                        />
                                                                    </Grid>
                                                                    <Grid lg={1}>
                                                                        <Box style={{ marginLeft: "20px", marginTop: "15px" }}>X</Box>
                                                                    </Grid>
                                                                </Grid>
                                                                <TableCell align="left">
                                                                    <Box style={{ display: "flex", justifyContent: "space-evenly", justifyItems: "center", alignContent: "center", alignItems: "center" }}>
                                                                        {/* <Box style={{ marginLeft: "-35px", marginRight: "20px" }}>
                                                                    <Typography>
                                                                        {x.label2}
                                                                    </Typography>
                                                                </Box> */}
                                                                        <Box>
                                                                            <Grid container>
                                                                                <Grid lg={11}>
                                                                                    <TextField
                                                                                        value={x.cil2}
                                                                                        style={{ width: "90px", marginLeft: "33px" }}
                                                                                        className='hola2'
                                                                                        onChange={(e) => handleDatosTextField2(x.id, e.target.value, 'cil2')}
                                                                                    />
                                                                                </Grid>
                                                                                <Grid lg={1}>
                                                                                    <Box style={{ marginLeft: "33px", marginTop: "15px" }}>X</Box>
                                                                                </Grid>
                                                                            </Grid>
                                                                        </Box>

                                                                    </Box>
                                                                </TableCell>
                                                            </Box>

                                                        </Box>

                                                    </TableCell>



                                                    <TableCell align="center">
                                                        <Box style={{ display: "flex", flexDirection: "column", justifyContent: "space-evenly", justifyItems: "center", alignContent: "center", alignItems: "center" }}>
                                                            <Box style={{ display: "flex", justifyContent: "space-evenly", justifyItems: "top", alignContent: "top", alignItems: "top" }}>
                                                                <TextField
                                                                    value={x.x1}
                                                                    style={{ maxWidth: "90px" }}
                                                                    className='hola3'
                                                                    onChange={(e) => handleDatosTextField2(x.id, e.target.value, 'x1')}
                                                                />
                                                                <Box>
                                                                    °
                                                                </Box>
                                                            </Box>
                                                            <TableCell align="left">
                                                                <Box style={{ display: "flex", justifyContent: "space-evenly", justifyItems: "top", alignContent: "top", alignItems: "top" }}>
                                                                    <Box>
                                                                        <TextField
                                                                            value={x.x2}
                                                                            style={{ width: "90px" }}
                                                                            className='hola4'
                                                                            onChange={(e) => handleDatosTextField2(x.id, e.target.value, 'x2')}
                                                                        />
                                                                    </Box>
                                                                    <Box>
                                                                        °
                                                                    </Box>
                                                                </Box>
                                                            </TableCell>
                                                        </Box>
                                                    </TableCell>



                                                    <TableCell align="center">
                                                        <Box style={{ display: "flex", flexDirection: "column", justifyContent: "space-evenly", justifyItems: "center", alignContent: "center", alignItems: "center" }}>
                                                            <Box style={{ display: "flex", justifyContent: "space-evenly", justifyItems: "top", alignContent: "top", alignItems: "top" }}>
                                                                <Box>
                                                                    <TextField
                                                                        value={x.rec1}
                                                                        style={{ maxWidth: "90px" }}
                                                                        className='hola5'
                                                                        onChange={(e) => handleDatosTextField2(x.id, e.target.value, 'rec1')}
                                                                    />
                                                                </Box>
                                                                <Box>
                                                                    °
                                                                </Box>
                                                            </Box>
                                                            <TableCell align="left">
                                                                <Box style={{ display: "flex", justifyContent: "space-evenly", justifyItems: "top", alignContent: "top", alignItems: "top" }}>
                                                                    <Box>
                                                                        <TextField
                                                                            value={x.rec2}
                                                                            style={{ width: "90px" }}
                                                                            className='hola6'
                                                                            onChange={(e) => handleDatosTextField2(x.id, e.target.value, 'rec2')}
                                                                        />
                                                                    </Box>
                                                                    <Box>
                                                                        °
                                                                    </Box>
                                                                </Box>
                                                            </TableCell>
                                                        </Box>
                                                    </TableCell>


                                                </>
                                            </TableRow>
                                        )
                                    }



                                </TableBody>

                            </Table>
                            {
                                text2 !== undefined &&
                                <TextField
                                    required
                                    style={{ marginTop: "20px", marginBottom: "20px" }}
                                    label={"Observaciones"}
                                    multiline
                                    fullWidth
                                    rows={3}
                                    onChange={(e) => handleDatosTextField2(text2[1].id, e.target.value, 'valor')}
                                    value={text2[1].valor}
                                />}
                        </>
                    }



                </TableContainer>



            </div>
            <Divider />
        </>
    )
}
